export default "__VITE_ASSET__aa707dfc__"